export default function HowItWorks() {
  const steps = [
    { number: 1, text: "Provide basic \n details." },
    { number: 2, text: "Compare and \n Select Offer." },
    { number: 3, text: "Complete \n Application Form." },
    { number: 4, text: "Sign Agreement  & Loan \n amount is credited." },
  ];

  return (
    <div className="w-screen  "> {/* Full width wrapper */}
      <div className="max-w-[400px] border pt-4 rounded-[30px]">
        <h2 className="text-[35px] font-bold text-center w-full flex items-center justify-center mb-10 font-bomstad-regular">
          How it Works
        </h2>

        <div className="relative w-full flex flex-col items-start  mx-auto max-w-[70%]">
          {/* Vertical line */}
          <div className="absolute left-[25px] top-0 h-[80%] w-[1.5px] bg-[#12F280]"></div>

          {steps.map((step, idx) => (
            <div
              key={idx}
              className="flex gap-4 h-[110px] items-start mb-6 relative w-full"
            >
              {/* Number Circle */}
              <div className="z-10 flex font-atkinson text-[30px] items-center justify-center min-w-[52px] min-h-[52px] rounded-full border-[2px] border-[#12F280] text-[#12F280] bg-white">
                {step.number}
              </div>

              {/* Step Text */}
              <p className="text-[18px] xs:text-[14px] font-atkinson text-gray-800  whitespace-pre-line">
                {step.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
